import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import { ProfileApi, RequestStrategyEnum, UsersApi, type ProfileResponse, type UserUpdateWithIdRequest } from '@shared/api';
import { $notificationStore } from '../notificationStore';

const getProfileEffect = createEffect(() => ProfileApi.getProfile());
const updateProfileEffect = createEffect((request: UserUpdateWithIdRequest) => UsersApi.updateUser(request));
const clearEvent = createEvent();

const $dataStore = createStore<ProfileResponse | null>(null)
  .on(getProfileEffect.done, (_, data) => data.result.data ?? null)
  .on(updateProfileEffect.done, (current, data) => (data.result as unknown as ProfileResponse) ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getProfileEffect.pending, (_, data) => data)
  .on(getProfileEffect.fail, () => false)
  .on(getProfileEffect.done, () => false)
  .on(updateProfileEffect.pending, (_, data) => data)
  .on(updateProfileEffect.fail, () => false)
  .on(updateProfileEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getProfileEffect, () => null)
  // .on(getProfileEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getProfileEffect.fail, () => 'Something went wrong while fetching Profile. Please try again.')
  .on(getProfileEffect.done, () => null)
  .reset(clearEvent);

const $actionErrorStore = createStore<string | null>(null)
  .on(updateProfileEffect, () => null)
  // .on(updateProfileEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(updateProfileEffect.fail, () => 'Something went wrong while updating Profile. Please try again.')
  .on(updateProfileEffect.done, () => null)
  .reset(clearEvent);
$actionErrorStore.watch((error) => $notificationStore.events.setError(error));

export const $profileStore = {
  events: {
    getProfile: ApiUtilsV2.wrapperApi(getProfileEffect, RequestStrategyEnum.Debounce).trigger,
    updateProfile: updateProfileEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
